import { apiLambdaRequest } from 'api/apiRequest'

const resetUsers = () => apiLambdaRequest('/dashboard/logout', null).post()

export const resetUsersApi = {
  resetUsers,
}
